import { render } from "./WatchHistory.vue?vue&type=template&id=0a5cdd02&ts=true"
import script from "./WatchHistory.vue?vue&type=script&lang=ts"
export * from "./WatchHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__